export const popupWindow = (url: string, w: number, h: number) => {
  // @ts-ignore: Object is possibly 'null'.
  const y = window.top.outerHeight / 2 + window.top.screenY - h / 2;
  // @ts-ignore: Object is possibly 'null'.
  const x = window.top.outerWidth / 2 + window.top.screenX - w / 2;

  return window.open(
    url,
    'Connect',
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`
  );
};
